var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 0.0625H22.4375V3.1875H19.3125V0.0625ZM19.3125 4.75H22.4375V7.875H19.3125V4.75ZM14.625 0.0625H17.75V3.1875H14.625V0.0625ZM14.625 4.75H17.75V7.875H14.625V4.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 11V15.6875H2.125V3.1875H11.5V1.625H2.125C1.7106 1.625 1.31317 1.78962 1.02015 2.08265C0.72712 2.37567 0.5625 2.7731 0.5625 3.1875V15.6875C0.5625 16.1019 0.72712 16.4993 1.02015 16.7924C1.31317 17.0854 1.7106 17.25 2.125 17.25H8.375V20.375H5.25V21.9375H17.75V20.375H14.625V17.25H20.875C21.2894 17.25 21.6868 17.0854 21.9799 16.7924C22.2729 16.4993 22.4375 16.1019 22.4375 15.6875V11H20.875ZM13.0625 20.375H9.9375V17.25H13.0625V20.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/Application.3d1681953e2e519d328543a0ca0ea799.svg";
export { ForwardRef as ReactComponent };